export default "__VITE_ASSET__d220855f__"